import countrisEmojiList from './countries.json';
export const countires: { [key: string]: any } = countrisEmojiList;
